var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-visual"
  }, [_c('swiper', {
    staticClass: "swiper",
    attrs: {
      "options": _vm.swiperOptions
    }
  }, [_c('swiper-slide', [_c('v-card', {
    attrs: {
      "flat": "",
      "rounded": "0"
    }
  }, [_c('div', {
    staticClass: "main-visual__inner"
  }, [_c('div', {
    staticClass: "main-visual__img d-md-none",
    staticStyle: {
      "background-image": "url(/images/main/visual.jpg)"
    }
  }), _c('div', {
    staticClass: "main-visual__img d-none d-md-block",
    staticStyle: {
      "background-image": "url(/images/main/visual.jpg)"
    }
  }), _c('v-container', [_c('tit-wrap-tertiary', {
    staticClass: "pb-0",
    scopedSlots: _vm._u([{
      key: "txt",
      fn: function () {
        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.$t('visual1.txt'))
          }
        })];
      },
      proxy: true
    }])
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('visual1.tit'))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "d-inline-block rounded-sm primary px-8px py-4px px-lg-12px py-lg-6px rounded--xl break-keep"
  }, [_vm._v(_vm._s(_vm.$t("사업명")))])])], 1)], 1)])], 1), _c('div', {
    staticClass: "swiper-control",
    attrs: {
      "slot": "pagination"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
      }
    },
    slot: "pagination"
  }, [_c('swiper-pagination-primary')], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }